import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { Tab as HeadlessUITab } from "@headlessui/react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface PanelsProps extends ComponentPropsWithoutRef<"div"> {
  children: ReactNode;
  className?: string;
}

export const Panels = ({ children, className = "", ...props }: PanelsProps) => (
  <HeadlessUITab.Panels
    as="div"
    data-testid="tab-panels"
    className={classNames("size-full overflow-auto", className)}
    {...props}
  >
    {children}
  </HeadlessUITab.Panels>
);

Panels.displayName = "Tab.Panels";
